import React, { useState } from 'react';
import { useServerLogs } from '../context/ServerLogContext';
import './ServerLogButton.css';

const ServerLogButton = () => {
  const { logs, showPopup, togglePopup, clearLogs, isConnected } = useServerLogs();
  const [filterType, setFilterType] = useState('all');

  // Filter logs based on selected type
  const filteredLogs = logs.filter(log => {
    if (filterType === 'all') return true;
    if (filterType === 'error') return log.type === 'error';
    if (filterType === 'info') return log.type !== 'error';
    return log.type === filterType;
  });

  // Count logs by type
  const errorCount = logs.filter(log => log.type === 'error').length;
  const infoCount = logs.filter(log => log.type !== 'error').length;

  if (!showPopup) {
    // Show only a button when popup is closed
    return (
      <div className="server-log-header-button" onClick={togglePopup}>
        <div className={`connection-indicator ${isConnected ? 'connected' : 'disconnected'}`}></div>
        <span className="server-log-text">Logs</span>
        {errorCount > 0 && (
          <span className="error-badge">{errorCount}</span>
        )}
      </div>
    );
  }

  return (
    <div className="server-log-header-popup">
      <div className="server-log-header-popup-header">
        <h4>
          Server Logs ({filteredLogs.length}/{logs.length})
          <div className={`connection-indicator ${isConnected ? 'connected' : 'disconnected'}`}></div>
        </h4>
        <div className="server-log-header-controls">
          <select 
            value={filterType} 
            onChange={(e) => setFilterType(e.target.value)}
            className="log-filter"
          >
            <option value="all">All</option>
            <option value="error">Error ({errorCount})</option>
            <option value="info">Info ({infoCount})</option>
          </select>
          <button onClick={clearLogs} className="clear-btn">Clear</button>
          <button onClick={togglePopup} className="close-btn">×</button>
        </div>
      </div>
      <div className="server-log-header-content">
        {logs.length === 0 ? (
          <div className="no-logs">No server logs available</div>
        ) : filteredLogs.length === 0 ? (
          <div className="no-logs">No logs match the selected filter</div>
        ) : (
          filteredLogs.slice(0, 10).map((log, index) => (
            <div
              key={index}
              className={`log-entry log-${log.type || 'info'}`}
            >
              <span className="log-timestamp">
                {new Date(log.timestamp).toLocaleTimeString()}
              </span>
              <span className="log-message">{log.message}</span>
              {log.details && (
                <div className="log-details">
                  <pre>{log.details}</pre>
                </div>
              )}
            </div>
          ))
        )}
        {filteredLogs.length > 10 && (
          <div className="more-logs">
            ... and {filteredLogs.length - 10} more logs
          </div>
        )}
      </div>
    </div>
  );
};

export default ServerLogButton; 